(function() {
  'use strict';

  var isBot = window.isPSA || false;

  if (!isBot) {
    return;
  }

  var resourcesLoaded = false;

  function loadJSScripts() {
    if (resourcesLoaded) return;
    resourcesLoaded = true;

    if (window.__speedOptimObserver) {
      window.__speedOptimObserver.disconnect();
    }

    var blockedScripts = document.querySelectorAll('script[type="text/lazyload"]');

    blockedScripts.forEach(function(oldScript) {
      var newScript = document.createElement('script');
      var dataSrc = oldScript.getAttribute('data-src');

      if (dataSrc) {
        newScript.src = dataSrc;
      }

      Array.from(oldScript.attributes).forEach(function(attr) {
        if (attr.name !== 'type' && attr.name !== 'data-src') {
          newScript.setAttribute(attr.name, attr.value);
        }
      });

      if (oldScript.innerHTML) {
        newScript.innerHTML = oldScript.innerHTML;
      }

      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    var deferredCSS = document.querySelectorAll('link[data-href]');
    deferredCSS.forEach(function(link) {
      link.href = link.getAttribute('data-href');
      link.removeAttribute('data-href');
    });

    var asyncLoadEvent = new Event('asyncLazyLoad');
    document.dispatchEvent(asyncLoadEvent);
  }

  var interactionEvents = [
    'mousemove',
    'mousedown', 
    'touchstart',
    'touchmove',
    'wheel',
    'keydown',
    'click'
  ];

  interactionEvents.forEach(function(eventName) {
    document.addEventListener(eventName, loadJSScripts, { 
      once: true,
      passive: true,
      capture: true 
    });
  });

  setTimeout(function() {
    if (!resourcesLoaded) {
      loadJSScripts();
    }
  }, 5000);

})();